var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewMediaIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.261719,
    y: 0.466797,
    width: 29.998,
    height: 29.998,
    rx: 5,
    fill: "#F6F7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40924 22.6881C6.58595 23.7557 7.51355 24.5699 8.6313 24.5699H22.1457C23.3896 24.5699 24.3981 23.5615 24.3981 22.3175V18.0269M6.40924 22.6881C6.38929 22.5675 6.37891 22.4437 6.37891 22.3175V8.80318C6.37891 7.55921 7.38734 6.55078 8.6313 6.55078H22.1457C23.3896 6.55078 24.3981 7.55921 24.3981 8.80318V18.0269M6.40924 22.6881L10.7121 18.3852C11.4779 17.7151 12.598 17.6418 13.4447 18.2062L14.0181 18.5885C14.8342 19.1326 15.9086 19.086 16.6745 18.4732L19.6569 16.0873C20.417 15.4792 21.4759 15.4315 22.284 15.9527C22.3735 16.0105 22.4532 16.0821 22.5286 16.1574L24.3981 18.0269M14.2623 12.1818C14.2623 13.4257 13.2539 14.4342 12.0099 14.4342C10.7659 14.4342 9.7575 13.4257 9.7575 12.1818C9.7575 10.9378 10.7659 9.92937 12.0099 9.92937C13.2539 9.92937 14.2623 10.9378 14.2623 12.1818Z",
    stroke: "#123051",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMediaIcon);
export default __webpack_public_path__ + "static/media/viewMediaIcon.c24f9d5176b41d298b8af38a64965283.svg";
export { ForwardRef as ReactComponent };